module.exports = {
  EXTERNAL_LINK: 1,
  POST: 2,
  YOUTUBE: 3,
  FILE: 4,
  HTML: 5
};